import { render, staticRenderFns } from "./BeneficiaryData.vue?vue&type=template&id=e2e7e23a&scoped=true"
import script from "./BeneficiaryData.vue?vue&type=script&lang=js"
export * from "./BeneficiaryData.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryData.vue?vue&type=style&index=0&id=e2e7e23a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e7e23a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VFlex,
  VLayout,
})
